module.exports = __webpack_public_path__ + "static/media/omar.65c80175.jpg";